module.exports = __webpack_public_path__ + "static/media/thanks.ad068474.mp3";